import { useSelector } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';

import { config } from 'src/config/config';
import { getUserInformation } from 'src/modules/user/selectors/userSelectors';

// Returns if the user is enabled to use the Care Navigation feature
export const useIsCareNavEnabledUser = () => {
    const { showSupportRequestCarenav } = useFlags();
    const { i18n } = useTranslation();
    const user = useSelector(getUserInformation);

    const isEnglishLanguageUser = i18n.language === config.defaultLanguage;
    const validUserLocation = user.country === 'United States' && isEnglishLanguageUser;

    return {
        isUserEnabledFlow: Boolean(
            validUserLocation && showSupportRequestCarenav && !user.isDependent,
        ),
    };
};
